/* #925 part A - the one motion rule: anything marked data-ea-reveal fades and rises once as it reaches the screen.
   data-ea-reveal="2" staggers it (0.08 s a step). Without this script, or with reduce-motion, everything just shows. */
(function () {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('ea-js');
  function watch(root) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    root.querySelectorAll('[data-ea-reveal]').forEach(function (el) {
      var step = parseInt(el.getAttribute('data-ea-reveal'), 10) || 0;
      if (step) el.style.setProperty('--ea-delay', (step * 0.08) + 's');
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(document); });
  else watch(document);
  // the theme editor re-renders a section in place
  document.addEventListener('shopify:section:load', function (e) { watch(e.target); });
})();

/* The menu bar's tone on a page built from data-ea-tone sections (a product landing page): dark words while a
   "light" section is under the bar. The homepage's RISE does its own; a page with no such section is left alone. */
(function () {
  function run() {
    var parts = document.querySelectorAll('[data-ea-tone]');
    if (!parts.length) return;
    var html = document.documentElement;
    // run straight from the scroll event, not a frame later: a handful of rects is cheap, and a page whose frames are
    // held (a background tab, a headless capture) still has the right bar the moment it is seen
    function tone() {
      var y = (parseFloat(getComputedStyle(html).getPropertyValue('--ea-nav-h')) || 64) / 2, light = false;
      for (var i = 0; i < parts.length; i++) {
        var r = parts[i].getBoundingClientRect();
        if (r.top <= y && r.bottom > y) { light = parts[i].getAttribute('data-ea-tone') === 'light'; break; }
      }
      html.classList.toggle('ea-light', light);
    }
    window.addEventListener('scroll', tone, { passive: true });
    window.addEventListener('resize', tone);
    window.addEventListener('load', tone);
    tone();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
